const io = require('socket.io-client');
let socket = null;
export default {
    namespaced: true,
    state: {
        bcIsActive: false,
        socketStatus: 'disconnected',
        token: `${new Date().getTime()}`,
    },
    getters: {
        socket: state => state.socket,
        socketStatus: state => state.socketStatus,
        bcIsActive: state => state.bcIsActive,
        token: state => state.token,
    },
    mutations: {
        SET_SOCKET(state, socket) {
            state.socket = socket;
        },
        SET_BC_STATUS(state, bcIsActive) {
            state.bcIsActive = bcIsActive;
        },
        SET_SOCKET_STATUS(state, status) {
            state.socketStatus = status;
        },
    },
    actions: {
        connect: ({ commit, dispatch, state }) => {
            return new Promise(function(resolve, reject) {
                const baseUrl =
                    process.env.NODE_ENV !== 'production'
                        ? 'http://192.168.0.113:3030'
                        : 'https://appelectoral.udg.mx';
                socket = io(baseUrl, {
                    path: '/websocket',
                });

                commit('SET_SOCKET_STATUS', 'connecting');

                socket.on('connect', err => {
                    commit('SET_SOCKET_STATUS', 'connected');
                    return err ? reject(err) : resolve();
                });

                socket.on('reconnect', err => {
                    console.log('RECONNECTED', err);
                    commit('SET_SOCKET_STATUS', 'connected');
                });

                socket.on('disconnect', () => {
                    console.log('WS DISCONNECTED');
                    commit('SET_SOCKET_STATUS', 'disconnected');
                });

                socket.on('cron-message', function(res) {
                    console.log('cron-message: ', res);
                });

                socket.on('admin.blockchain.status', function(data) {
                    commit('SET_BC_STATUS', data.status);
                });

                socket.on('admin.elections.update', function(data) {
                    commit('elecciones/UPDATE_ELECCTION', data, { root: true });
                });

                socket.on('reports.elections.progress', function(data) {
                    console.log('reports.elections.progress', data);

                    if (data.token !== state.token) {
                        return;
                    }
                    let progress = (data.current * 100) / (data.total || 1);
                    progress = progress.toFixed(2);

                    commit(
                        'reportes/SET_CSV_STATUS',
                        {
                            progress: Number(progress),
                            label: 'reports.elections.progress',
                        },
                        { root: true }
                    );
                });

                socket.on('reports.elections.finished', function(data) {
                    console.log('reports.elections.finished', data.name);
                    if (data.token !== state.token) {
                        return;
                    }

                    commit(
                        'reportes/SET_CSV_STATUS',
                        { progress: 0, label: '' },
                        { root: true }
                    );
                    dispatch(
                        'reportes/generateCsv',
                        {
                            csv: data.csv,
                            name: data.name,
                        },
                        { root: true }
                    );
                });

                socket.on('reports.elections.error', function(data) {
                    console.error('reports.elections.error');
                    if (data.token !== state.token) {
                        return;
                    }

                    console.error(data);

                    commit(
                        'reportes/SET_CSV_STATUS',
                        { progress: 0, label: '' },
                        { root: true }
                    );
                    dispatch(
                        'errorMessage',
                        'Ha ocurrido un error mientras se procesaba un csv',
                        { root: true }
                    );
                });
            });
        },
    },
};
